exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table td, .el-table th {\n  padding: 8px 0;\n}\n.el-dialog__footer {\n  padding : 0 20px 20px 0;\n}\n.el-dialog__title{\n  line-height: 50px;\n  padding-left: 20px;\n}\n.el-tabs__nav-wrap::after {\n  height : 0;\n}\n.van-radio-group {\n  line-height: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a153766","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketViewMain.vue
// module id = 1013
// module chunks = 75